module.exports = __webpack_public_path__ + "img/conception.0afdb376.png";